import _ from 'lodash'
import { List, Map } from 'immutable'
import { LAYOUT_MODE } from '../../constants/toUnits'
import { TAB_TYPES } from '../../lib/tab-utils'

export function processRemoveChildElements(childUID) {
  return (elem) => {
    if (elem.get('type') === 'Form') {
      let ret = elem
      _.each(LAYOUT_MODE, (mode) => {
        const child = ret.getIn(['props', mode, 'children'], Map())
        ret = ret.setIn(
          ['props', mode, 'children'],
          child.map((row) => {
            let retRow = row
            retRow = retRow.set(
              'children',
              retRow.get('children', Map()).map((col) =>
                col.set(
                  'children',
                  col.get('children', List()).filter((id) => childUID.indexOf(id) === -1)
                )
              )
            )
            return retRow
          })
        )
      })
      ret.set(
        'children',
        ret.get('children', List()).filter((id) => childUID.indexOf(id) === -1)
      )
      return ret
    } else if (elem.get('type') === 'Stack' || elem.get('type') === 'Scroll') {
      let ret = elem
      _.each(LAYOUT_MODE, (mode) => {
        const order = ret.getIn(['props', mode, 'order'], List())
        ret = ret.setIn(
          ['props', mode, 'order'],
          order.filter((id) => childUID.indexOf(id) === -1)
        )
      })
      ret.set(
        'children',
        ret.get('children', List()).filter((id) => childUID.indexOf(id) === -1)
      )
      return ret
    } else if (TAB_TYPES.includes(elem.get('type'))) {
      let ret = elem
      _.each(LAYOUT_MODE, (mode) => {
        const tabs = ret.getIn(['props', mode, 'tabs'], List())
        ret = ret.setIn(
          ['props', mode, 'tabs'],
          tabs.map((tab) =>
            tab.set(
              'children',
              tab.get('children', List()).filter((id) => childUID.indexOf(id) === -1)
            )
          )
        )
      })
      ret.set(
        'children',
        ret.get('children', List()).filter((id) => childUID.indexOf(id) === -1)
      )
      return ret
    } else {
      let children = elem
        .get('children', List())
        .filter((id) => {
          if (List.isList(id)) {
            return id
          } else {
            return childUID.indexOf(id) === -1
          }
        })
        .map((id) => {
          if (List.isList(id)) {
            return id.filter((eid) => childUID.indexOf(eid) === -1)
          } else {
            return id
          }
        })
      if (elem.get('type') === 'Modal' && elem.getIn(['props', 'isExp'])) {
        const tabs = elem.getIn(['props', 'lg', 'tabs'], List())
        return elem.set('children', children).setIn(
          ['props', 'lg', 'tabs'],
          tabs.map((tab) =>
            tab.set(
              'children',
              tab.get('children', List()).filter((id) => childUID.indexOf(id) === -1)
            )
          )
        )
      } else {
        return elem.set('children', children)
      }
    }
  }
}
